import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { formatters } from 'common';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';

const titleOptions = ['CUSIP', 'TICKER_SYMBOL', 'OCC_SYMBOL'];

const TransferPanelPositionJournal = ({ quantity, securityId, securityIdType, price }) => (
  <div className={styles.rightPane}>
    <DefListColumn
      className={styles.defList}
      title={
        titleOptions.includes(securityIdType) ? <FormattedMessage {...messages[securityIdType]} /> : securityIdType
      }
      data={securityId}
      dataTestHandle="positionJournal_ticker"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.quantity} />}
      data={quantity}
      dataTestHandle="positionJournal_quantity"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.amount} />}
      data={formatters.formatDollars(price)}
      dataTestHandle="positionJournal_amount"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.costBasis} />}
      data={formatters.formatDollars(price)}
      dataTestHandle="positionJournal_costBasis"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.miscIncome} />}
      data={formatters.formatDollars(price)}
      dataTestHandle="positionJournal_income"
    />
  </div>
);

TransferPanelPositionJournal.propTypes = {
  quantity: PropTypes.number.isRequired,
  securityIdType: PropTypes.string.isRequired,
  securityId: PropTypes.string.isRequired,
  price: PropTypes.number,
};

TransferPanelPositionJournal.defaultProps = {
  price: 0,
};

export default TransferPanelPositionJournal;



// WEBPACK FOOTER //
// ./src/components/TransferPanelPositionJournal/TransferPanelPositionJournal.jsx